import type { ReactNode } from 'react';

export interface ToolbarBangProps {
  /** Bên trái: thường là `SegmentedControl`. */
  trai?: ReactNode;
  /** Bên phải: ô tìm, các select lọc, nút. */
  phai?: ReactNode;
}

/**
 * Thanh công cụ trên một bảng: nhóm chọn bên trái, tìm + lọc bên phải, **một
 * hàng** và tự xuống dòng khi hẹp.
 *
 * Bản cũ xếp mỗi ô lọc một dòng kèm nhãn riêng, nên bốn ô lọc ăn gần 200px
 * chiều cao trước khi thấy dòng dữ liệu đầu tiên. Ở đây nhãn nằm trong
 * placeholder của chính ô, và cả thanh cao đúng một hàng nút.
 */
export function ToolbarBang({ trai, phai }: ToolbarBangProps) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2">
      {trai}
      {phai && <div className="ml-auto flex flex-wrap items-center gap-2">{phai}</div>}
    </div>
  );
}
